<template>
  <v-container fluid>
    <material-card
      icon="mdi-clipboard-text"
      inline
      title="Order Gap"
    >
      <a @click="$router.back()">
        <v-btn
          v-if="$vuetify.breakpoint.smAndUp"
          elevation="1"
          absolute
          right
          top
        >
          <v-icon left>mdi-arrow-left</v-icon>back
        </v-btn>
        <v-btn
          v-else
          fixed
          right
          fab
          small
          color="grey lighten-2"
          elevation="1"
          class="mr-n2 mt-10"
          style="opacity: 0.6"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </a>
      <v-card-text
        class="pt-0 pr-1"
        :class="{
          'd-block py-3': $vuetify.breakpoint.xs,
          'd-flex align-center': $vuetify.breakpoint.smAndUp
        }"
      >
        <!--Filter Section Start -->
        <v-row>
          <v-col cols="12" md="4">
            <label class="font-weight-medium body-2"> Class </label>
             <v-select
                placeholder="Select class"
                class="my-0 py-1"
                v-model="selectedClassSectionArray"
                item-value="id"
                :items="classSectionArray"
                @input="getStudentDetails(true)"
                key="id"
                item-text="name"
              >
              </v-select>

          </v-col>
          <v-col cols="12" md="4" >
            <v-btn
              elevation="1"
              @click="generateIndent()"
              class="ms-2 mt-5"
              color="success"
            >
              Generate Indent
            </v-btn>
          </v-col>
        </v-row>
        <!--Filter section end -->
      </v-card-text>
      <v-divider class="my-0" />
      <v-data-table
        :items-per-page="100"
        item-key="id"
        :headers="headers"
        :items="studentList"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:item.checkbox="{ item }">
          <v-checkbox
            color="accent"
            @change="selectStudentHandler(item)"
            v-model="item.isSelected"
            :disabled="item.newOrderStatus === 'PENDING' ||item.missingProducts.length==0"
          ></v-checkbox>
        </template>
        <template v-slot:item.missingProducts="{item}">
          <v-chip-group
            active-class="primary--text"
            column
          >
            <v-chip
              v-for="(missingProduct, index) in item.missingProducts"
              :key="`${index}_${missingProduct}`"
            >
              {{ missingProduct.name }}
            </v-chip>
          </v-chip-group>
        </template>
        <template v-slot:no-data>
          <v-card-subtitle class="d-flex justify-center"
            >No Data Available</v-card-subtitle
          >
        </template>
      </v-data-table>
      <!--Pagination start-->
      <v-row>
        <v-col cols="4" sm="3">
          <v-select
            v-model="pageSize"
            :items="pageSizes"
            label="Items per Page"
            @change="handlePageSizeChange"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="9">
          <v-pagination
            v-model="page"
                :length="totalPages"
                :total-visible="100"
                @input="handlePageChange"
          >
          </v-pagination>
        </v-col>
      </v-row>
    </material-card>
    <template>
  <div class="text-center">
    <v-dialog
      v-model="responseDialog"
      width="800"
    >
    <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title>Generate Indent Student Status</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row justify-center>
              <v-col cols="12">
                <v-data-table :headers="responseHeaders"
                  :items="response" class="elevation-1">

                </v-data-table>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      text
                      @click="responseDialog = false"
                    >
                      Close
                    </v-btn>
                  </v-card-actions>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
    </v-dialog>
  </div>
</template>
    <!-- Loader Start -->
    <loading-icon :value="isLoading" />
    <!-- Loader End -->
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import MaterialCard from '@/components/template/MaterialCard'
import _ from 'lodash'
import constants from '@/utils/constants'
import Utils from '@/utils'
export default {
  name: 'uniformIndent',
  components: { MaterialCard },
  async created () {
    this.reorderUniform = this.checkModuleAccess('reorderUniform')
    await this.onStart()
  },
  mounted () {},
  data: function () {
    return {
      classSectionArray: [],
      selectedClassSectionArray: null,
      headers: [
        { text: 'Select', sortable: true, value: 'checkbox', width: '5%' },
        {
          text: 'Enrollment Code',
          sortable: true,
          value: 'studentEnrollment.enrollmentCode'
        },
        {
          text: 'Student Name',
          sortable: true,
          value: 'studentEnrollment.studentName'
        },
        {
          text: 'Gender',
          sortable: false,
          value: 'studentEnrollment.gender'
        },
        {
          text: 'Class & Section',
          sortable: false,
          value: 'studentClass.name'
        },
        {
          text: 'Order ID',
          sortable: false,
          value: 'newOrderID'
        },
        {
          text: 'Order Status',
          sortable: false,
          value: 'newOrderStatus'
        },
        {
          text: 'Missing Product',
          sortable: false,
          value: 'missingProducts'
        }
      ],
      studentList: [],
      franchiseeID: '',
      academicYearID: '',
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      isLoading: false,
      groupedProducts: [],
      classID: [],
      classSection: '',
      selectedStudentList: [],
      response: [],
      responseDialog: false,
      responseHeaders: [
        {
          text: 'Enrollment Code',
          sortable: true,
          value: 'enrollmentCode'
        },
        {
          text: 'Student Name',
          sortable: true,
          value: 'studentName'
        },
        {
          text: 'Status',
          sortable: true,
          value: 'status'
        },
        {
          text: 'Message',
          sortable: true,
          value: 'message'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      // Reset the class dropdown selected options on franchisee change
      this.selectedClassSectionArray = null
      await this.onStart()
    },
    academicYear: async function (val) {
      this.selectedClassSectionArray = null
      await this.onStart()
    }
  },
  methods: {
    onStart: async function () {
      try {
        this.isDisable = false
        if (!this.inProgress) {
          this.inProgress = true
          if (this.franchisee) {
            this.franchiseeID = this.franchisee.id
            // this.walletBalanceFunc()
          } else {
            this.franchiseeID = ''
          }
          if (this.academicYear) {
            this.academicYearID = this.academicYear.id
          } else {
            this.academicYearID = ''
          }
          if (this.franchiseeID && this.academicYearID) {
            this.getClassList()
            // this.getStudentDetails()
          }
          this.inProgress = false
        }
      } finally {
        this.inProgress = false
      }
    },
    selectStudentHandler: function (student) {
      // Searching in the selected student list
      let isSelectedIndex = this.selectedStudentList
        .map((item) => item.studentAdmissionID)
        .indexOf(student.id)
      if (isSelectedIndex > -1) {
        // This student is already selected
        if (!student.isSelected) {
          // Deselecting the student as checkbox is unchecked
          this.selectedStudentList.splice(isSelectedIndex, 1)
        }
      } else {
        let selectedStudent = {}
        selectedStudent.studentAdmissionID = student.id
        selectedStudent.orderID = student.orders[0].orderID
        selectedStudent.enrollmentCode = student.studentEnrollment.enrollmentCode
        selectedStudent.studentName = student.studentEnrollment.studentName
        selectedStudent.products = _.map(student.missingProducts, product => {
          return { productID: product.productID, quantity: product.quantity }
        })
        this.selectedStudentList.push(selectedStudent)
      }
    },
    generateIndent: async function () {
      try {
        if (!this.selectedStudentList.length) {
          return this.errMsg('Please select students to place order')
        }
        this.$dialog.confirm({
          title: 'Place Order',
          text: 'Are you sure you want to place this order?',
          actions: {
            false: {
              text: 'No'
            },
            true: {
              color: 'success',
              text: 'Yes',
              handle: async () => {
                try {
                  console.log('clicked yes')
                  const data = await http.post(
                    `${constants.API_URL}/api/order-gap/place-order`,
                    {
                      selectedStudent: this.selectedStudentList
                    }
                  )
                  console.log('responce ::: ', data)
                  this.isLoading = false
                  if (data) {
                    this.response = data.data
                    this.responseDialog = true
                    // this.okMsg('Order Placed successfully...')
                  }
                } catch (e) {
                  const errorMessage = (e && e.response && e.response.data.message) || e.message
                  this.errMsg(errorMessage)
                }
              }
            }
          }
        })
      } catch (error) {

      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true

        let { data } = await http.get(
          `${constants.API_URL}/api/student/get-all-classby-franchisee`,
          {
            params: {
              franchiseeID: this.franchisee?.id || '',
              academicYearID: this.academicYear?.id || ''
            }
          }
        )

        this.classSectionArray = data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getStudentDetails: async function (isFromFilter = false) {
      try {
        this.studentList = []
        this.selectedStudentList = []
        let payload = {}
        if (isFromFilter) {
          this.page = 1
        }
        payload.franchiseeID = this.franchisee.id
        payload.academicYearID = this.academicYear.id
        if (this.selectedClassSectionArray) {
          payload.classID = [this.selectedClassSectionArray]
        } else {
          this.errMsg('Please select class.')
        }

        const { data } = await http.post(
          `${constants.API_URL}/api/student-uniform-list/student-order-list`,
          Object.assign(
            {
              page: this.page - 1,
              size: this.pageSize
            },
            payload
          )
        )
        this.studentList = data.rows
        for (const student of this.studentList) {
          let order = _.find(student.orders, ckOrder => {
            return ckOrder.kitType === 'CURRICULUM_KIT_2'
          })
          if (order && order.previousOrder) {
            student.newOrderID = order.previousOrder.reOrderID ? order.previousOrder.reOrderID.orderID : ''
            student.newOrderStatus = order.previousOrder.reOrderID ? order.previousOrder.reOrderID.status : ''
          } else {
            student.newOrderID = null
            student.newOrderStatus = null
          }
        }
        this.totalPages = data.totalPages
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    handlePageChange (value) {
      this.page = value
      this.$router.push({ name: 'orderGap', params: { current: this.page } })
      this.getStudentDetails()
      this.isLoading = true
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.page = 1
      this.getStudentDetails()
    },

    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    }

  }
}
</script>
<style scoped>
.height-auto {
  height: 100vh;
  overflow-y: scroll;
}
.holder {
  position: relative;
}
.applyAttendance {
  position: absolute;
  right: 142px;
  top: 58px;
  z-index: 1;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
